import { observer } from "mobx-react"
import React, { useEffect, useState } from 'react';
import { SelectGenericFromTable } from '../universal/Axios';
import { getStore } from "../../Store"
import { Button } from '@mui/material';
import apiClient from '../../apiClient';


const SelectInputAudio = observer(() => {
    let store = getStore()
    const triggerDensityNetworkCloudFunction = (combined_bucket_folder, combined_file_name, id, saved_network_run_id = null) => {
        store.updateStatusMessage("Running Density Network over " + combined_file_name)
        apiClient.post(
            //"http://127.0.0.1:8080",
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/cloud-density-network",
            //"https://cloud-density-network-ob2apavl4q-uc.a.run.app/",
            {
                "cloud_environment_folder": combined_bucket_folder,
                "cloud_environment_file_name": combined_file_name,
                "auto_run": "false",
                "use_cloud_storage_audio": "true"
                //"network_run_queue_id": "762475bb-1feb-4d5c-ae86-4890ec80a65d",
                //"auto_run": "true",
                //"is_cloud_run": "true",
            }
        ).then((res) => {
            store.updateSuccessMessage("Successfully ran Density Network!")

            if (res?.status === 200) {
                var res_data = res.data
                var returned_network_run_id = res_data["network_run_id"];
                if (returned_network_run_id && returned_network_run_id.length > 0) {
                    triggerDensityNetworkCloudFunction(combined_bucket_folder, combined_file_name, id, returned_network_run_id);
                }
            }
        }).catch(function (error) {
            console.log(error)
            store.updateErrorMessage("Error on Density Network Run: likely timeout")
        });
    }

    var query = "select *, snsi.id as snsi_id, snsi.name as full_name, af1.name as instrument_file_name, af2.name as noise_file_name, af3.name as combined_file_name, af3.bucket_folder as combined_bucket_folder from signal_noise_separation_input snsi "
        + "left join audio_file af1 on snsi.instrument_audio_file_id = af1.id "
        + "left join audio_file af2 on snsi.noise_audio_file_id = af2.id "
        + "left join audio_file af3 on snsi.combined_audio_file_id = af3.id limit 10;";

    useEffect(() => {
        store = getStore()
        if (store.updateInstrumentNoiseSeparationInputs != null) {
            SelectGenericFromTable(query, store.updateInstrumentNoiseSeparationInputs)
        }
    }, []);

    store.instrumentNoiseSeparationInputs.slice().sort(function (a, b) { return a.run_date - b.run_date; })
    return (
        <div>
            {store.instrumentNoiseSeparationInputs.slice().sort(function (a, b) { return a.run_date - b.run_date; }).map(x =>
                <div style={{ marginBottom: "30px" }}>
                    <div style={{ fontSize: "30px" }}>Name: <b>{x.full_name}</b></div>
                    <div style={{ fontSize: "15px" }}>Run Date: <b>{x.run_date}</b></div>
                    <div style={{ width: '80%', height: "50px" }}>
                        <span style={{ marginLeft: "10px", width: '40%', float: 'left' }}>
                            <div><i>Noise Stack Level: {x.noise_stack_level}</i></div>
                            <div><i>Noise to Instrument Volume Ratio: {x.noise_to_instrument_volume_ratio}</i></div>
                        </span>
                        <span style={{ marginLeft: "10px", width: '40%', float: 'left' }}>
                            <Button variant="contained" onClick={() => {
                                triggerDensityNetworkCloudFunction(x.combined_bucket_folder, x.combined_file_name, x.id)
                            }}>Separate Audio</Button>
                        </span>
                    </div>

                    <div style={{ float: "center", width: '50%' }}>
                        <div>
                            Instrument File: {x.instrument_file_name}
                        </div>
                        <div>
                            Noise File: {x.noise_file_name}
                        </div>
                        <div>
                            Combined File: {x.combined_file_name}
                        </div>
                    </div>
                    </div>
            )}
        </div>
    );
});


export default SelectInputAudio;